"use client";

import { Sparkles, Search } from "lucide-react";

interface SoftHeroProps {
  settings: any;
  searchQuery: string;
  setSearchQuery: (q: string) => void;
}

export default function SoftHero({
  settings,
  searchQuery,
  setSearchQuery,
}: SoftHeroProps) {
  return (
    <section className="relative pt-12 pb-16 px-4 overflow-hidden text-center">
      <div className="absolute top-10 left-12 w-28 h-28 bg-blue-300/30 rounded-full blur-2xl pointer-events-none animate-pulse" />
      <div className="absolute top-24 right-16 w-36 h-36 bg-indigo-300/25 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-4xl mx-auto space-y-4 relative z-10">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/90 shadow-[4px_4px_12px_#d9e2ec,-4px_-4px_12px_#ffffff] border border-white/80 text-blue-600 text-xs font-black uppercase tracking-wider">
          <Sparkles className="w-3.5 h-3.5 text-blue-500" />
          <span>Verified Marketplace</span>
        </div>

        <h1 className="text-3xl sm:text-5xl lg:text-6xl font-black text-slate-900 tracking-tight leading-tight">
          {settings?.store_name || "ClassiAds Marketplace"}
        </h1>

        <p className="text-sm sm:text-base text-slate-500 max-w-xl mx-auto font-medium">
          {settings?.store_tagline ||
            "Discover verified products, fresh produce, and local essentials."}
        </p>

        <div className="max-w-2xl mx-auto pt-4">
          <div className="bg-white p-2 sm:p-2.5 rounded-3xl sm:rounded-full shadow-[8px_8px_20px_#d5e0ec,-8px_-8px_20px_#ffffff] border border-white flex flex-col sm:flex-row items-center gap-2">
            <div className="flex items-center gap-3 px-4 w-full flex-1">
              <Search className="w-5 h-5 text-slate-400 flex-shrink-0" />
              <input
                type="text"
                placeholder="Search products or classified items..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full text-sm bg-transparent outline-none text-slate-800 placeholder-slate-400 font-medium"
              />
            </div>
            <button
              type="button"
              className="w-full sm:w-auto px-8 py-3 rounded-full bg-blue-600 hover:bg-blue-500 text-white text-xs font-black tracking-wide shadow-lg shadow-blue-500/30 transition-all cursor-pointer"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}